/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import DocumentTitle from 'utils/DocumentTitle';
import { t } from 'utils/translates';

import MyPage from './Main/MyPage';
import MyRatingAndStat from './Main/MyRatingAndStat';
import MyBalance from './Main/MyBalance';
import MyMessages from './Main/MyMessages';
import UpdateAccount from './Main/UpdateAccount';
import CustomizeNotifications from './Main/CustomizeNotifications';

import NewTasksList from './EarnMoney/NewTasksList';
import TasksToExecutors from './EarnMoney/TasksToExecutors';
import InProcessTasksList from './EarnMoney/InProcessTasksList';
import CheckedTasksList from './EarnMoney/CheckedTasksList';
import RemakeTasksList from './EarnMoney/RemakeTasksList';
import FinishedTasksList from './EarnMoney/FinishedTasksList';
import CanceledByOwnerTasksList from './EarnMoney/CanceledByOwnerTasksList';
import NotDoneTasksList from './EarnMoney/NotDoneTasksList';
import ArbitrationTasksList from './EarnMoney/ArbitrationTasksList';
import ChosenTasksList from './EarnMoney/ChosenTasksList';
import HiddenTasksList from './EarnMoney/HiddenTasksList';
import TaskViewAsExecutor from './EarnMoney/TaskViewAsExecutor';

import MyAllTasksList from './MyTasks/MyAllTasksList';
import MyActiveTasksList from './MyTasks/MyActiveTasksList';
import MyStoppedTasksList from './MyTasks/MyStoppedTasksList';
import MyFinishedTasksList from './MyTasks/MyFinishedTasksList';
import MyArchivedTasksList from './MyTasks/MyArchivedTasksList';
import MyPremoderationTasksList from './MyTasks/MyPremoderationTasksList';
import MyOnCorrectionTasksList from './MyTasks/MyOnCorrectionTasksList';
import MyLockedTasksList from './MyTasks/MyLockedTasksList';
import ExecutionsMyTasksList from './MyTasks/ExecutionsMyTasksList';
import TaskViewAsOwner from './MyTasks/TaskViewAsOwner';
import TaskCreate from './MyTasks/TaskCreate';
import TaskEdit from './MyTasks/TaskEdit';
import TaskCopy from './MyTasks/TaskCopy';

import TopUsers from './Users/TopUsers';
import MyUsersBlackList from './Users/MyUsersBlackList';
import UserProfile from './Users/UserProfile';

import NewCompetitions from './Competitions/NewCompetitions';
import MyParticipation from './Competitions/MyParticipation';
import FinishedCompetitions from './Competitions/FinishedCompetitions';
import ContestView from './Competitions/ContestView';

import ReferralMyStat from './ReferralProgram/ReferralMyStat';
import PromotionalMaterials from './ReferralProgram/PromotionalMaterials';

import ReferenceInformationContentMain from './Help/ReferenceInformation/ContentMain';
import ReferenceInformationContentSearch from './Help/ReferenceInformation/ContentSearch';
import ReferenceInformationContentView from './Help/ReferenceInformation/ContentView';

import NotificationsList from './Notifications/NotificationsList';
import NotificationView from './Notifications/NotificationView';

import PublicApiDoc from './ApiDoc/PublicApiDoc';
import ManageApiDoc from './ApiDoc/ManageApiDoc';

import Error404 from '../Error404';

import GlobalPopUps from '../../../components/Common/GlobalPopUps';

const getRoutes = () => [
  {
    path: '/account*',
    exact: true,
    component: () => <Redirect from="/" to="/earn-money/new-tasks" />
  },
  {
    path: '/',
    exact: true,
    component: () => <Redirect from="/" to="/earn-money/new-tasks" />
  },
  {
    path: '/main/my-page',
    component: MyPage,
    pageTitle: t('Моя страница')
  },
  {
    path: '/main/my-rating-and-stat',
    exact: true,
    component: () => (
      <Redirect
        from="/"
        to="/main/my-rating-and-stat/all-statuses/user-days-stat"
      />
    ),
    pageTitle: t('Мой рейтинг и статистика')
  },
  {
    path: '/main/my-rating-and-stat/:myRatingTabName/:myStatTabName',
    component: MyRatingAndStat,
    pageTitle: t('Мой рейтинг и статистика')
  },
  {
    path: '/main/my-balance',
    component: MyBalance,
    pageTitle: t('Мой баланс')
  },
  {
    path: '/main/messenger',
    component: MyMessages,
    pageTitle: t('Мои сообщения')
  },
  {
    path: '/main/update-account',
    component: UpdateAccount,
    pageTitle: t('Редактировать данные')
  },
  {
    path: '/main/customize-notifications',
    component: CustomizeNotifications,
    pageTitle: t('Настройка уведомлений')
  },
  {
    path: '/earn-money/new-tasks',
    component: TasksToExecutors,
    pageTitle: t('Новые задания')
  },
  {
    path: '/earn-money/new-tasks-v1',
    component: NewTasksList,
    pageTitle: t('Новые задания')
  },
  {
    path: '/earn-money/new-tasks-v2',
    component: TasksToExecutors,
    pageTitle: t('Новые задания')
  },
  {
    path: '/earn-money/in-process-tasks',
    component: InProcessTasksList,
    pageTitle: t('В процессе выполнения')
  },
  {
    path: '/earn-money/checked-tasks',
    component: CheckedTasksList,
    pageTitle: t('На проверке')
  },
  {
    path: '/earn-money/remake-tasks',
    component: RemakeTasksList,
    pageTitle: t('На проверке')
  },
  {
    path: '/earn-money/finished-tasks',
    component: FinishedTasksList,
    pageTitle: t('Завершённые')
  },
  {
    path: '/earn-money/canceled-by-owner-tasks',
    component: CanceledByOwnerTasksList,
    pageTitle: t('Отказано заказчиками')
  },
  {
    path: '/earn-money/not-done-tasks',
    component: NotDoneTasksList,
    pageTitle: t('Невыполненные')
  },
  {
    path: '/earn-money/arbitration-tasks',
    component: ArbitrationTasksList,
    pageTitle: t('Арбитраж')
  },
  {
    path: '/earn-money/chosen-tasks',
    component: ChosenTasksList,
    pageTitle: t('Избранные')
  },
  {
    path: '/earn-money/hidden-tasks',
    component: HiddenTasksList,
    pageTitle: t('Скрытые')
  },
  {
    path: '/earn-money/task-view/:taskId',
    component: TaskViewAsExecutor,
    pageTitle: t('Просмотр задачи для выполнения')
  },
  {
    path: '/my-tasks/all-tasks',
    component: MyAllTasksList,
    pageTitle: t('Все задания')
  },
  {
    path: '/my-tasks/active-tasks',
    component: MyActiveTasksList,
    pageTitle: t('Активные задания')
  },
  {
    path: '/my-tasks/stopped-tasks',
    component: MyStoppedTasksList,
    pageTitle: t('Остановленные задания')
  },
  {
    path: '/my-tasks/finished-tasks',
    component: MyFinishedTasksList,
    pageTitle: t('Завершённые задания')
  },
  {
    path: '/my-tasks/archived-tasks',
    component: MyArchivedTasksList,
    pageTitle: t('Архивные задания')
  },
  {
    path: '/my-tasks/premoderation',
    component: MyPremoderationTasksList,
    pageTitle: t('На премодерации')
  },
  {
    path: '/my-tasks/on-correction',
    component: MyOnCorrectionTasksList,
    pageTitle: t('Требует корректировки')
  },
  {
    path: '/my-tasks/locked-tasks',
    component: MyLockedTasksList,
    pageTitle: t('Заблокировано')
  },
  {
    path: '/my-tasks/executions',
    component: ExecutionsMyTasksList,
    pageTitle: t('Выполнения')
  },
  {
    path: '/my-tasks/view/:taskId',
    component: TaskViewAsOwner,
    pageTitle: t('Просмотр моей задачи')
  },
  {
    path: '/my-tasks/create',
    component: TaskCreate,
    pageTitle: t('Добавить задание')
  },
  {
    path: '/my-tasks/edit/:taskId',
    component: TaskEdit,
    pageTitle: t('Редактировать задание')
  },
  {
    path: '/my-tasks/copy/:taskId',
    component: TaskCopy,
    pageTitle: t('Копировать задание')
  },
  {
    path: '/users/top-users/:topList',
    component: TopUsers,
    pageTitle: t('Топ пользователей')
  },
  {
    path: '/users/my-users-black-list',
    component: MyUsersBlackList,
    pageTitle: t('Мой черный список')
  },
  {
    path: '/users/profile/:userId',
    component: UserProfile,
    pageTitle: ''
  },
  {
    path: '/competitions/new',
    component: NewCompetitions,
    pageTitle: t('Конкурсы / Новые')
  },
  {
    path: '/competitions/my-participation',
    component: MyParticipation,
    pageTitle: t('Конкурсы / Я участвую')
  },
  {
    path: '/competitions/finished',
    component: FinishedCompetitions,
    pageTitle: t('Конкурсы / Законченные')
  },
  {
    path: '/competition/:id',
    component: ContestView,
    pageTitle: t('Конкурс')
  },
  {
    path: '/referral-program/my-stat',
    component: ReferralMyStat,
    pageTitle: t('Статистика партнёрской программы')
  },
  {
    path: '/referral-program/promotional-materials',
    component: PromotionalMaterials,
    pageTitle: t('Рекламные материалы')
  },
  {
    path: '/help/reference-information',
    exact: true,
    component: ReferenceInformationContentMain,
    pageTitle: t('Справка')
  },
  {
    path: '/help/reference-information/search',
    component: ReferenceInformationContentSearch,
    pageTitle: t('Поиск по справке')
  },
  {
    path: '/help/reference-information/view/:seoUrl',
    component: ReferenceInformationContentView,
    pageTitle: t('Справка')
  },
  {
    path: '/notifications',
    exact: true,
    component: NotificationsList,
    pageTitle: t('Уведомления')
  },
  {
    path: '/notifications/view/:noticeId',
    component: NotificationView,
    pageTitle: t('Просмотр уведомления')
  },
  {
    path: '/notifications/:categoryId',
    component: NotificationsList,
    pageTitle: t('Уведомления')
  },
  {
    path: '/api-doc',
    component: PublicApiDoc,
    pageTitle: t('API документация')
  },
  {
    path: '/manage-api-doc',
    component: ManageApiDoc,
    pageTitle: t('API документация')
  },
  {
    path: '*',
    component: Error404,
    pageTitle: '404'
  }
];

const RouteWithSubRoutes = route => (
  <Route
    path={route.path}
    exact={route.exact || false}
    render={props => {
      // pass the sub-routes down to keep nesting
      if (route.pageTitle) {
        return (
          <DocumentTitle title={route.pageTitle}>
            <route.component {...props} routes={route.routes} />
          </DocumentTitle>
        );
      }
      return <route.component {...props} routes={route.routes} />;
    }}
  />
);

const Content = () => (
  <React.Fragment>
    <GlobalPopUps />
    <Switch>
      {getRoutes().map(route => (
        <RouteWithSubRoutes key={`route${route.path}`} {...route} />
      ))}
    </Switch>
  </React.Fragment>
);

export default Content;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Content.js